import { graphql } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

import { List } from './List';

export const UsersPage_ExternalUsersTabPanel_AllExternalUsers_QueryDocument =
  graphql(`
    query UsersPage_ExternalUsersTabPanel_AllExternalUsers_Query {
      findAllExternalUsers {
        ...UsersPage_List_User_Fragment
        statusId
      }
    }
  `);

export const ExternalUsersTabPanel = () => {
  const { genericStatusesCodeMap } = useReferencesContext();

  const { data, isSuccess } = useGraphQLQuery(
    UsersPage_ExternalUsersTabPanel_AllExternalUsers_QueryDocument,
  );

  if (isSuccess) {
    const allExternaUsers = data.findAllExternalUsers;

    const enabledExternalUsers = allExternaUsers.filter(
      (user) => user.statusId === genericStatusesCodeMap.Enabled._id,
    );

    return <List users={enabledExternalUsers} />;
  }

  return <Loading />;
};
